// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Insurer-module__formBox--wLygZ {
    flex-grow: 1;
    padding: 30px;
    width: 80%;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
}

.Insurer-module__btnBoxNext--IsGzK {
    display: flex;
    justify-content: end;
}

.Insurer-module__titleBox--gtGai>h4 {
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);
}
.Insurer-module__titleOterBox--Lb1Nq>h4 {
    margin: 15px 0 10px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);
}

.Insurer-module__titleBox--gtGai>p {
    margin: 10px 0 20px 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-title);
}

.Insurer-module__twoLine--HULRQ {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

.Insurer-module__twoLine--HULRQ>div {
    width: 50%;
    max-width: 350px;
}
.Insurer-module__oneLine--WroJy > div {
    width: 100%;
}
.Insurer-module__checkboxField--zljNn {
    margin-bottom: 10px;
}

.Insurer-module__errorBox--ek62l {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #ffe2e2;
    border-radius: 20px;
    padding: 5px;
}

.Insurer-module__textErrorBox--bbSnE>p {
    margin: 0;
    font-size: 14px;
    color: var(--color-error);
}
.Insurer-module__iconRed--YVDd6 {
    color: var(--color-error);
    font-size: 25px;
}

@media (max-width: 950px) {
    .Insurer-module__twoLine--HULRQ {
        flex-direction: column
    }

    .Insurer-module__twoLine--HULRQ>div {
        width: 100%;
         max-width: 900px;
    }

    .Insurer-module__formBox--wLygZ {
        width: 80%;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/health-ai/step-2/ui/Insurer.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;SACV,gBAAgB;IACrB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".formBox {\r\n    flex-grow: 1;\r\n    padding: 30px;\r\n    width: 80%;\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.titleBox>h4 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n.titleOterBox>h4 {\r\n    margin: 15px 0 10px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n\r\n.titleBox>p {\r\n    margin: 10px 0 20px 0;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n\r\n.twoLine {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.twoLine>div {\r\n    width: 50%;\r\n    max-width: 350px;\r\n}\r\n.oneLine > div {\r\n    width: 100%;\r\n}\r\n.checkboxField {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.errorBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #ffe2e2;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.textErrorBox>p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n    color: var(--color-error);\r\n}\r\n.iconRed {\r\n    color: var(--color-error);\r\n    font-size: 25px;\r\n}\r\n\r\n@media (max-width: 950px) {\r\n    .twoLine {\r\n        flex-direction: column\r\n    }\r\n\r\n    .twoLine>div {\r\n        width: 100%;\r\n         max-width: 900px;\r\n    }\r\n\r\n    .formBox {\r\n        width: 80%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `Insurer-module__formBox--wLygZ`,
	"btnBoxNext": `Insurer-module__btnBoxNext--IsGzK`,
	"titleBox": `Insurer-module__titleBox--gtGai`,
	"titleOterBox": `Insurer-module__titleOterBox--Lb1Nq`,
	"twoLine": `Insurer-module__twoLine--HULRQ`,
	"oneLine": `Insurer-module__oneLine--WroJy`,
	"checkboxField": `Insurer-module__checkboxField--zljNn`,
	"errorBox": `Insurer-module__errorBox--ek62l`,
	"textErrorBox": `Insurer-module__textErrorBox--bbSnE`,
	"iconRed": `Insurer-module__iconRed--YVDd6`
};
export default ___CSS_LOADER_EXPORT___;
